module.exports = "<!-- Place all UI elements intended to be present across all routes in this file -->\n<div class=\"app\">\n  <div ui-view=\"home\" ng-show=\"$root.$state.includes('app.home')\"></div>\n  <div ui-view></div>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/app.html
 ** module id = 24
 ** module chunks = 0
 **/